export enum PendingLoaderLayouts {
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  AMOUNT = 'AMOUNT'
}
